import {
  PaymentSettingsProduct,
  type PaymentSettingsTab,
} from '@/features/payment-settings';
import { requireAdministratorAccess, requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const paymentSettingsSearchSchema = z.object({
  tab: z.enum(['gateway', 'catalog', 'history']).optional(),
});

export const Route = createFileRoute(
  '/_app/settings/products/payment-methods/$productCode'
)({
  component: SettingsProductPaymentMethodsRoute,
  validateSearch: paymentSettingsSearchSchema,
  beforeLoad: async () => {
    // Espelha o guard da API: `products.catalog.read` + `@RequireGroups('insurer.administrator')`.
    const [isAdministrator, canRead] = await Promise.all([
      requireAdministratorAccess(),
      requirePermissions(['products.catalog.read']),
    ]);
    if (!isAdministrator || !canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function SettingsProductPaymentMethodsRoute() {
  const { productCode } = Route.useParams();
  const { tab = 'gateway' } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <PaymentSettingsProduct
      productCode={productCode}
      tab={tab}
      onTabChange={(next: PaymentSettingsTab) =>
        void navigate({ search: { tab: next }, replace: true })
      }
    />
  );
}
